export interface CookiebotUser {
  ExecutedBy: string;
  ChangeType: string;
  ChangeEntityId: number;
  ChangeEntityTable: string;
  Action: string;
  Notes: string;
}
